import { render, staticRenderFns } from "./AllOrdersTodayList.vue?vue&type=template&id=985d8d32&lang=pug&"
import script from "./AllOrdersTodayList.vue?vue&type=script&lang=js&"
export * from "./AllOrdersTodayList.vue?vue&type=script&lang=js&"
import style0 from "./AllOrdersTodayList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports